<template>
  <div class="strategy-manager page-box">
    <query-header
      ref="header"
      @toQuery="toQuery"
      @searchHandle="searchHandle"
      @addHandle="addHandle"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th
            >
              策略渠道
            </vs-th>
            <vs-th>
              策略名称
            </vs-th>
            <vs-th>
              策略来源
            </vs-th>
            <vs-th>
              策略作者
            </vs-th>
            <vs-th>
              成员白名单
            </vs-th>
            <vs-th>
              超时时间(分)
            </vs-th>
            <vs-th>
              匹配模式
            </vs-th>
            <vs-th>
              备注
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              创建时间
            </vs-th>
            <vs-th>
              更新时间
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
            >
              <vs-td
                style="min-width: 60px"
              >
                {{tr.id}}
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                <span>{{getSourceType(tr)}}</span>
              </vs-td>
              <vs-td>
                {{tr.strategyName}}
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                {{getSource(tr)}}
              </vs-td>
              <vs-td
                style="max-width: 400px"
              >
                {{getAuthor(tr)}}
              </vs-td>
              <vs-td style="max-width: 320px">
                {{tr.sourceType === 6 ? getLarkMembers(tr) : getTelegramMembers(tr)}}
              </vs-td>
              <vs-td
                style="min-width: 120px"
              >
                {{tr.expirePeriod || '-'}}
              </vs-td>
              <vs-td>
                <div>{{tr.matchMode==1?'无需匹配':'正则匹配'}}</div>
                <div v-if="tr.matchMode == 2">{{tr.pattern}}</div>
              </vs-td>
              <vs-td>
                {{tr.remark || '-'}}
              </vs-td>
              <vs-td
                style="min-width: 100px;"
              >
                <span
                  class="self-tag"
                  :style="getStyle(tr)"
                >
                  {{getStatus(tr)}}
                </span>
              </vs-td>
              <vs-td>
                {{parseTime(tr.createTime)}}
              </vs-td>
              <vs-td>
                {{parseTime(tr.updateTime)}}
              </vs-td>
              <vs-td>
                <el-button
                  type="text"
                  v-if="isAuth('wx:forward:strategy:update')"
                  class="theme-color"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
<!--                v-if="isAuth('wx:forward:strategy:delete')"-->
<!--                <el-button
                  iconClass="trash1"
                  class="delete-btn"
                  @click="deleteHandle(tr.id)"
                >删除</el-button>-->
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-statrgy-manager-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-statrgy-manager-dialog>
      <edit-statrgy-manager-dialog
        ref="edit"
        :dialog-show="editDialogShow"
        :form-data="formData"
        @close="closeEditDialog"
        @edit-success="editSuccess"
      ></edit-statrgy-manager-dialog>
  </div>
</template>

<script>
import editStatrgyManagerDialog from '@/components/sys/strategyManager/editStatrgyManagerDialog'
import addStatrgyManagerDialog from "@/components/sys/strategyManager/addStatrgyManagerDialog";
import queryHeader from "@/components/sys/strategyManager/queryHeader";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils'
import initData from "@/mixins/initData";
import {deleteStrategy} from "@/api/sys/statrgyManager/statrgyManager";
export default {
  name: "index",
  components: {
    addStatrgyManagerDialog,
    editStatrgyManagerDialog,
    queryHeader,
  },
  data() {
    return {
      addDialogShow: false,
      editDialogShow: false,
      formData: {},
      strategyName: '',
      red: '#D85E5F',
      green: '#41B883',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/forwardStrategy/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order':'desc',
      }

      let header = this.$refs.header;
      if(header.strategyName){
        this.params.strategyName = header.strategyName;
      }
      if(header.status !== ''){
        this.params.status = header.status;
      }
      if(header.type){
        this.params.sourceType = header.type;
      }

      return true;
    },
    getSourceType(row) {
      switch (row.sourceType) {
        case 1:
          return '微信公众号';
        case 2:
          return '个人微信';
        case 3:
          return 'Webhook';
        case 4:
          return '其他(爬虫)';
        case 5:
          return 'Telegram Bot';
        case 6:
          return 'Lark应用';
        default:
          return '-';
      }
    },
    getSource(tr){
      return tr.sourceType !=2 ? (tr.sourceOfficialName || '-') : (tr.sourceNickname || '-');
    },
    getAuthor(tr){
      return tr.authorNickName ? tr.authorNickName: tr.authorId;
    },
    getTelegramMembers(tr){
      if(tr.sourceType !== 5 || !tr.telegramMembers || !tr.telegramMembers.length) return '-';
      return tr.telegramMembers.map(item => item.displayName || item.username || item.userId).join(', ');
    },
    getLarkMembers(tr){
      if(!tr.larkMembers || !tr.larkMembers.length) return '-';
      return tr.larkMembers.map(item => item.name || item.openId).join(', ');
    },

    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);

    },
    addUserSuccess(){
      setTimeout(() => {
        this.addDialogShow = false;
      },200);
      this.searchHandle();
    },
    editHandle(row){
      this.formData = row;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
      /*let edit = this.$refs.edit;
      edit.$refs.sliderbar.active = true;*/
    },
    editSuccess(){
      this.formData = {};
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.formData = {};
      this.editDialogShow = false;
      /*let edit = this.$refs.edit;
      edit.$refs.sliderbar.active = false;*/
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '启用';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
    deleteHandle(id){
      let ids = [id];
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteStrategy(ids).then(() => {
          this.$message({
            type: 'success',
            message: '已删除'
          });
          this.searchHandle();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.strategy-manager {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
}
</style>
